import { PayloadAction, createSlice } from '@reduxjs/toolkit';

export type AuthPayload = {
    accessToken: string;
    refreshToken: string;
    sessionId: string;
    role?: string;
    permissions?: string[];
    companyId?: string;
};

export type AuthState = {
    accessToken: string;
    refreshToken: string;
    sessionId: string;
    role?: string;
    permissions?: string[];
    companyId?: string;
};

const initialState: AuthState = {
    accessToken: '',
    refreshToken: '',
    sessionId: '',
    role: '',
    permissions: [],
    companyId: '',
};

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        logout: () => {
            return initialState;
        },
        setAuth: (state, action: PayloadAction<AuthPayload>) => {
            return { ...state, ...action.payload };
        },
    },
    selectors: {
        selectAccessToken: (state) => state.accessToken,
        selectRefreshToken: (state) => state.refreshToken,
        selectRole: (state) => state.role,
        selectPermissions: (state) => state.permissions,
        selectCompanyId: (state) => state.companyId,
        selectSessionId: (state) => state.sessionId,
    },
});

export const { setAuth, logout } = authSlice.actions;
export const {
    selectAccessToken,
    selectRefreshToken,
    selectRole,
    selectPermissions,
    selectCompanyId,
    selectSessionId,
} = authSlice.selectors;

export default authSlice.reducer;
